
import { defineComponent, PropType } from "vue";
import ErrorMessage from "@/components/ErrorMessage.vue";

export default defineComponent({
  name: "AdminForm",
  props: {
    bigTitle: { type: String },
    header1: { type: String },
    header2: { type: String },
    info: { type: String },
    referenceText: { type: String },
    inputText: { type: String },
    errorMessages: { type: Object as PropType<string[]> },
  },
  components: {
    ErrorMessage,
  },
  setup(_, context) {
    return {
      context,
    };
  },
});
